import { Model } from 'modules/core/lib/mobx-rest'

interface IBookkeeper {
  id?: string
  access_id: string
  company_id?: string
  cycle_id?: string
}

class Bookkeeper extends Model<IBookkeeper> {
  static urlRoot() {
    return '/bookkeepers_management/bookkeepers'
  }
}

export default Bookkeeper
